/* 
* This file is auto-generated by Graphweaver. 
* Please do not edit it directly.
*/
import * as Types from '../../../../backend/src/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FinaliseSubscriptionMutationVariables = Types.Exact<{
  sessionId: Types.Scalars['String']['input'];
}>;


export type FinaliseSubscriptionMutation = { __typename?: 'Mutation', finaliseSubscription?: { __typename?: 'StripeProduct', id: string, name?: string | null } | null };


export const FinaliseSubscriptionDocument = gql`
    mutation finaliseSubscription($sessionId: String!) {
  finaliseSubscription(sessionId: $sessionId) {
    id
    name
  }
}
    `;
export type FinaliseSubscriptionMutationFn = Apollo.MutationFunction<FinaliseSubscriptionMutation, FinaliseSubscriptionMutationVariables>;

/**
 * __useFinaliseSubscriptionMutation__
 *
 * To run a mutation, you first call `useFinaliseSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinaliseSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finaliseSubscriptionMutation, { data, loading, error }] = useFinaliseSubscriptionMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useFinaliseSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<FinaliseSubscriptionMutation, FinaliseSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinaliseSubscriptionMutation, FinaliseSubscriptionMutationVariables>(FinaliseSubscriptionDocument, options);
      }
export type FinaliseSubscriptionMutationHookResult = ReturnType<typeof useFinaliseSubscriptionMutation>;
export type FinaliseSubscriptionMutationResult = Apollo.MutationResult<FinaliseSubscriptionMutation>;
export type FinaliseSubscriptionMutationOptions = Apollo.BaseMutationOptions<FinaliseSubscriptionMutation, FinaliseSubscriptionMutationVariables>;